module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"delete-webhook":"Delete Webhook Subscription","webhook-deleted":"Webhook Subscription deleted","failed-delete-webhook":"Failed to delete webhook subscription"}}')
  delete Component.options._Ctor
}
